<template>
    <div class="producthea-card">
        <div class="producthea" :class="productc_nav?'productc_nav':''" ref="producthea">
            <div class="producthea-left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :class="itemClass" v-for="(nav,index) in positionNav" :key="index" :to="nav.path" >{{ nav.title }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <slot></slot>
        </div>
        <div class="linesd" v-if="linesd"></div>
    </div>
</template>

<script>
    import { session } from "../storage/storage.js";

    export default {
        name: "position-bar",
        props:{
            productc_nav:{
                type:Boolean,
                default:false
            },
            positionNav:{
                type:Array,
                default: () => []
            },
            linesd: {
                type: Boolean,
                default: true
            }
        },
        data(){
            return {
                itemClass:''
            }
        },
        mounted(){
            this.itemClass=session.get('channel_id')==1?'woodpecker':session.get('channel_id')==2?'dte':'dba'
        },
        methods:{
            getPositionNavBar(){
                this.$emit('getPositionNavBar',this.$refs.producthea.offsetHeight)
            },
        }
    }
</script>

<style>
.producthea-card {
  min-height: 60px;
  background-color: #ffffff;
  z-index: 999999;
}
    .productc_nav {
        position: fixed;
        z-index: 999;
        top: 0%;
        background-color: #fff;
        background: rgba(255, 255, 255, .72);
        backdrop-filter: saturate(180%) blur(20px);
    }

    .producthea{
        width: 1400px;
        min-height: 60px;
        font-size: 20px;
        display: flex;
        padding: 0 260px;
        justify-content: space-between;
        align-items: center;
    }
    .producthea-left{
        font-size: 28px;
        color: #5d5f5f;
    }
    .producthea-right{
        display: flex;

    }

    .producthea-righttitle{
        display: flex;
        font-size: 16px;
        flex-wrap: wrap;
        margin-left: -24px;
    }
    .producthearight-item{
        margin-left: 24px;
    }
    .producthearight-item:first-child{
        margin-left: 0px;
    }
    .producthea-righticon{
        width: 16px;
        height: 16px;
        margin-left: 9px;
    }
    .producthea-righticon img{
        width: 100%;
        height: 100%;
    }
    .linesd{
        width: 1400px;
        height: 1px;
        background: #EAEAEA;
        margin: 0 auto;
    }

    .el-breadcrumb__inner {
        cursor: pointer;
        font-size: 16px;
    }
    .el-breadcrumb__inner.is-link {
        color: #606266;
    }

    .woodpecker .is-link:hover{
        color: #e62129;
    }
    .dte .is-link:hover{
        color: #1a4698;
    }
    .dba .is-link:hover{
        color: #000000;
    }
</style>